import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./PartnersInfo.css";

const PartnersInfo = () => {
  const [activeTab, setActiveTab] = useState("technology");

  const partnerCategories = {
    technology: {
      title: "Technology Partners",
      icon: "🔧",
      description:
        "Leading cybersecurity technology providers that enhance our platform capabilities",
      partners: [
        {
          name: "Cloud Security Alliance",
          type: "Cloud Security",
          description: "Advanced cloud security monitoring and assessment tools",
          capabilities:
            "Multi-cloud security posture management, container security, serverless monitoring",
        },
        {
          name: "Threat Intelligence Consortium",
          type: "Threat Intelligence",
          description:
            "Real-time global threat intelligence and indicator feeds",
          capabilities:
            "Dark web monitoring, IOC feeds, threat actor attribution, attack pattern analysis",
        },
        {
          name: "Certificate Authority Network",
          type: "SSL/TLS Monitoring",
          description:
            "Comprehensive SSL certificate monitoring and transparency logging",
          capabilities:
            "Certificate transparency monitoring, expiration alerts, misconfigurations detection",
        },
        {
          name: "DNS Security Partners",
          type: "DNS Intelligence",
          description:
            "Advanced DNS monitoring and threat detection capabilities",
          capabilities:
            "Passive DNS analysis, domain generation algorithm detection, DNS tunneling identification",
        },
      ],
    },
    consulting: {
      title: "Consulting Partners",
      icon: "👥",
      description:
        "Expert cybersecurity consulting firms providing specialized advisory services",
      partners: [
        {
          name: "Elite Cyber Advisory Group",
          type: "Strategic Consulting",
          description:
            "C-level cybersecurity strategy and governance consulting",
          capabilities:
            "Board-level reporting, risk assessment, compliance strategy, incident response planning",
        },
        {
          name: "VAPT Specialists Network",
          type: "Penetration Testing",
          description:
            "Certified ethical hackers and penetration testing experts",
          capabilities:
            "External penetration testing, red team exercises, social engineering assessments",
        },
        {
          name: "Compliance Advisory Partners",
          type: "Regulatory Compliance",
          description:
            "Specialized compliance consulting for various industry regulations",
          capabilities:
            "PCI DSS, HIPAA, SOX, GDPR compliance consulting and audit preparation",
        },
        {
          name: "Incident Response Alliance",
          type: "Incident Response",
          description:
            "24/7 incident response and digital forensics specialists",
          capabilities:
            "Emergency response, digital forensics, malware analysis, recovery planning",
        },
      ],
    },
  };

  const tabs = Object.entries(partnerCategories);

  return (
    <div className="row clearfix">
      <div className="col-sm-2" />
      <div className="col-sm-9" style={{ padding: 0 }}>
        <div className="container-fluid">
          {/* Header */}
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>Partners & Alliances</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Partners Info
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>

          {/* Intro */}
          <div className="row clearfix">
            <div className="col-xl-12">
              <div className="card pi-card">
                <div className="header">
                  <h2>Strategic Partnerships</h2>
                  <p className="text-muted">
                    iOdin collaborates with leading cybersecurity organizations,
                    technology providers, and industry experts to deliver
                    comprehensive digital presence protection services.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="row clearfix">
            {/* Left rail */}
            <div className="col-xl-3 col-lg-3 col-md-12">
              <div className="card pi-card sticky-desktop">
                <div className="header">
                  <h2>Partner Categories</h2>
                </div>
                <div className="body">
                  <ul
                    className="pi-pills"
                    role="tablist"
                    aria-label="Partner categories"
                  >
                    {tabs.map(([key, category]) => {
                      const selected = activeTab === key;
                      return (
                        <li key={key}>
                          <button
                            type="button"
                            className={`pi-pill w-100 ${
                              selected ? "active" : ""
                            }`}
                            onClick={() => setActiveTab(key)}
                            role="tab"
                            aria-selected={selected}
                            aria-controls={`panel-${key}`}
                            id={`tab-${key}`}
                          >
                            <span className="pi-pill-icon">
                              {category.icon}
                            </span>
                            <span className="pi-pill-label">
                              {category.title}
                            </span>
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div className="card pi-card">
                <div className="header">
                  <h2>Partnership Benefits</h2>
                </div>
                <div className="body">
                  <ul className="list-unstyled pi-benefits">
                    <li className="mb-2">
                      <i className="fa fa-shield text-success mr-2" />
                      Enhanced threat detection
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-users text-success mr-2" />
                      Expert advisory access
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-globe text-success mr-2" />
                      Global threat intelligence
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-certificate text-success mr-2" />
                      Professional certifications
                    </li>
                    <li className="mb-2">
                      <i className="fa fa-cogs text-success mr-2" />
                      Advanced technology integration
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Right content */}
            <div className="col-xl-9 col-lg-9 col-md-12">
              <div
                className="card pi-card"
                role="tabpanel"
                id={`panel-${activeTab}`}
                aria-labelledby={`tab-${activeTab}`}
              >
                <div className="header">
                  <h2 className="d-flex align-items-center">
                    <span className="mr-2">
                      {partnerCategories[activeTab].icon}
                    </span>
                    {partnerCategories[activeTab].title}
                  </h2>
                  <p className="text-muted">
                    {partnerCategories[activeTab].description}
                  </p>
                </div>

                {/* Partner tiles grid */}
                <div className="body">
                  <div className="pi-grid">
                    {partnerCategories[activeTab].partners.map(
                      (partner, index) => (
                        <div key={index} className="card pi-tile">
                          <div className="body">
                            <h5 className="mb-2">{partner.name}</h5>
                            <span className="badge badge-primary pi-badge">
                              {partner.type}
                            </span>
                            <p className="text-muted mb-3">
                              {partner.description}
                            </p>
                            <h6 className="mb-1">Capabilities</h6>
                            <p className="small text-secondary mb-0">
                              {partner.capabilities}
                            </p>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom row */}
          <div className="row clearfix">
            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="card pi-card">
                <div className="header">
                  <h2>Become a Partner</h2>
                </div>
                <div className="body">
                  <p>
                    Join our partner ecosystem and help organizations worldwide
                    protect their digital presence. We're always looking for
                    innovative technology providers and expert consultants.
                  </p>

                  <h6>Partnership Opportunities</h6>
                  <ul>
                    <li>Technology integration partnerships</li>
                    <li>Expert advisory consulting</li>
                    <li>Channel partner programs</li>
                    <li>Research and development collaboration</li>
                  </ul>

                  <Link to="/contact" className="btn btn-primary btn-round">
                    Partner Inquiry
                  </Link>
                </div>
              </div>
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12">
              <div className="card pi-card">
                <div className="header">
                  <h2>Partner Portal</h2>
                </div>
                <div className="body">
                  <p>
                    Existing partners can access exclusive resources, training
                    materials, and collaboration tools through our secure partner
                    portal.
                  </p>

                  <h6>Portal Features</h6>
                  <ul>
                    <li>Technical integration documentation</li>
                    <li>Joint marketing resources</li>
                    <li>Training and certification programs</li>
                    <li>Partner support and communication</li>
                  </ul>

                  <button className="btn btn-success btn-round" disabled>
                    Partner Login (Coming Soon)
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* /Bottom row */}
        </div>
      </div>
    </div>
  );
};

export default PartnersInfo;
